import { useTranslation } from 'react-i18next'
import { setLocale, SUPPORTED_LOCALES } from '@/i18n/i18n'

const LABELS = { uz: 'UZ', ru: 'RU', en: 'EN' }

export default function LanguageSwitcher({ className = '' }) {
  const { i18n } = useTranslation()
  const current  = i18n.language

  return (
    <div className={`flex items-center gap-0.5 ${className}`} role="group" aria-label="Language">
      {SUPPORTED_LOCALES.map((lng) => {
        const isActive = current === lng
        return (
          <button
            key={lng}
            onClick={() => setLocale(lng)}
            aria-pressed={isActive}
            className="px-2 py-1 rounded-lg text-xs font-semibold transition-all"
            style={
              isActive
                ? { background: 'var(--coral)', color: '#fff' }
                : { background: 'transparent', color: 'var(--ink-3)', border: 'none' }
            }
            onMouseEnter={e => { if (!isActive) e.currentTarget.style.background = 'var(--bg-soft)' }}
            onMouseLeave={e => { if (!isActive) e.currentTarget.style.background = 'transparent' }}
          >
            {LABELS[lng]}
          </button>
        )
      })}
    </div>
  )
}
